<div class="row pg-style">
  <div class="col-sm-12 pg-style">
    <div class="row search-banner">
      <div class="col-sm-12 search-banner-col">
        <h2 class="h3 search-banner-title">Billing</h2>
      </div>
    </div>
    <div class="row search-nav">
      <div class="col-sm-12 search-nav-col">
        <ul class="list-inline search-nav-list">
          <li><button type="button" (click)="switchBillingTab('Invoices')" [class.search-nav-active]="activeTab() === 'Invoices'">Invoices</button></li>
          <li><button type="button" (click)="switchBillingTab('My Reports')" [class.search-nav-active]="activeTab() === 'My Reports'">My Reports</button></li>
          <li><button type="button" (click)="switchBillingTab('Historical Reports')" [class.search-nav-active]="activeTab() === 'Historical Reports'">Historical Reports</button></li>
          @if (billingAttributeFeatures().includes('paymentHistory') && selectedAdminPlan() !== 'DDMN') {
          <li><button type="button" (click)="switchBillingTab('PaymentHistory')" [class.search-nav-active]="activeTab() === 'PaymentHistory'">Payment History</button></li>
          }
          <li><button type="button" (click)="switchBillingTab('Recurring ACH Setup')" [class.search-nav-active]="activeTab() === 'Recurring ACH Setup'">Recurring ACH Setup</button></li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="row billing-search">
  <div class="col-sm-12 card">
    @if (selectedAdminPlan() && (activeTab() === 'Invoices' || activeTab() === 'Historical Reports')) {
    <div class="billing-component">
      @if (clientSearch.renderClientSearch()) {
      <bmt-client-search
        [attr.data-render-state]="clientSearch.clientSearchRenderState()"
        [selectedAdminPlan]="selectedAdminPlan()"
        [allSubClientsSelectFeature]="true"
        (clientSelected)="clientSelected($any($event))"
        (subClientSelected)="subClientSelected($any($event))"
        (resetSelected)="handleClientSearchReset()"
        (selectedAllSubClients)="selectedAllSubClients($any($event))"></bmt-client-search>
      }
      @if (showReports()) {
        <billing [billing]="billingFeatures()" [feed]="billingFeed()" [selectedAdminPlan]="selectedAdminPlan()" [userFeed]="$any(userFeed())"></billing>
      }
    </div>
    }

    @if (activeTab() === 'My Reports') {
    <div class="report-component">
      <billing-available-reports></billing-available-reports>
    </div>
    }

    @if (activeTab() === 'EBill' || activeTab() === 'Recurring ACH Setup' || activeTab() === 'PaymentHistory') {
    <div class="billing-component">
      @if (ebillError()) {
      <div class="error">{{ebillError()}}</div>
      }
      @if (clientSearch.renderClientSearch()) {
      <bmt-client-search
        [attr.data-render-state]="clientSearch.clientSearchRenderState()"
        [selectedAdminPlan]="selectedAdminPlan()"
        [allSubClientsSelectFeature]="activeTab() === 'Recurring ACH Setup' || activeTab() === 'PaymentHistory'"
        [multiSelect]="activeTab() === 'Recurring ACH Setup'"
        (clientSelected)="clientSelected($any($event))"
        (subClientSelected)="subClientSelected($any($event))"
        (resetSelected)="handleClientSearchReset()"
        (selectedAllSubClients)="selectedAllSubClients($any($event))"></bmt-client-search>
      }
      @if (showClientSubclientInfo()) {
        <div class="row group-info">
          @if (!allSubClients()) {
          <div>
            <p><strong>Group:</strong> <span><strong>{{subGroupInfo()?.[0]?.client?.planAcronym}}</strong> {{subGroupInfo()?.[0]?.client?.name}} {{subGroupInfo()?.[0]?.client?.specifiedId}}</span></p>
            <p><strong>Subgroup:</strong>
              @for (item of subGroupInfo(); track item.specifiedId; let isLast = $last) {
              <span>{{item.specifiedId}} {{item.name}} <strong>{{isLast ? '' : ', '}}</strong></span>
              }
            </p>
          </div>
          }
          @if (allSubClients() && selectedClient()) {
          <div>
            <p><strong>Group:</strong> <span><strong>{{selectedClient()?.planAcronym}}</strong> {{selectedClient()?.name}} {{selectedClient()?.specifiedId}}</span></p>
            <p><strong>Subgroup:</strong>
              <span>'All Subgroups'</span></p>
          </div>
          }
        </div>
        @if (showPaymentHistory() && activeTab() === 'PaymentHistory') {
        <div>
          <billing [billing]="['bmtPaymentHistory']" [feed]="billingFeed()" [selectedAdminPlan]="selectedAdminPlan()"></billing>
        </div>
        }
        @if (activeTab() === 'Recurring ACH Setup') {
        <div>
          <ach-payment [isAllSubclientSelected]="allSubClients()" [groupDetails]="allSubClients() ? selectedClient() : subGroupInfo()" (resetSelected)="resetSelected()"></ach-payment>
        </div>
        }
      }
    </div>
    }
  </div>
</div>
